/**
 * The colours a user can pick when defining a status.
 *
 * A fixed palette rather than a free colour picker: each entry carries a
 * matching dot / background / text triple, and the text-on-background contrast
 * has been chosen deliberately. A free picker would let someone build an
 * unreadable chip, and the badge draws text ON the background.
 *
 * The first three are the built-ins' own colours, so a custom status sits
 * beside them without looking like it came from a different product.
 */
export interface StatusPaletteEntry {
  /** Stable id, used as the radio value. Not shown to the user. */
  id: string;
  dotColor: string;
  bgColor: string;
  textColor: string;
}

export const STATUS_PALETTE: StatusPaletteEntry[] = [
  { id: "blue", dotColor: "#1976d2", bgColor: "#e3f2fd", textColor: "#1565c0" },
  { id: "green", dotColor: "#388e3c", bgColor: "#e8f5e9", textColor: "#2e7d32" },
  { id: "grey", dotColor: "#9e9e9e", bgColor: "#f5f5f5", textColor: "#616161" },
  { id: "amber", dotColor: "#d97706", bgColor: "#fef3c7", textColor: "#92400e" },
  { id: "red", dotColor: "#dc2626", bgColor: "#fee2e2", textColor: "#991b1b" },
  { id: "purple", dotColor: "#7c3aed", bgColor: "#ede9fe", textColor: "#5b21b6" },
  { id: "teal", dotColor: "#0d9488", bgColor: "#ccfbf1", textColor: "#115e59" },
  { id: "pink", dotColor: "#db2777", bgColor: "#fce7f3", textColor: "#9d174d" },
];

export const DEFAULT_STATUS_PALETTE_ENTRY = STATUS_PALETTE[3];

/** Find the palette entry a stored colour came from, for the edit form. */
export function paletteEntryForDot(dotColor: string): StatusPaletteEntry {
  return (
    STATUS_PALETTE.find((e) => e.dotColor.toLowerCase() === dotColor.toLowerCase()) ??
    DEFAULT_STATUS_PALETTE_ENTRY
  );
}
